import inventoryAPI from '@/services/api/inventory'
import Object from '@/utils/modules/ObjectUtil'
import { DateTime } from 'luxon'

const index = {
	namespaced: true,
	state: () => ({
		capacity: '0',
		count: '0',
		amount: '0',
		currentVolume: undefined,
		volumeUnit: '',
		itemDetail: undefined,
		deriveItems: [],
		isItemChanged: [],
		editItem: undefined,
		itemIndex: undefined,
	}),
	getters: {
		getExpiredDay: state => {
			const diffDays = DateTime.fromISO(
				state.editItem.expireDatetime
			).diffNow('days')
			return Math.floor(diffDays + 1)
		},
		wasItemChanged: state => {
			return state.isItemChanged.every(item => !item)
		},
	},
	mutations: {
		initDivideInfo: state => {
			state.capacity = '0'
			state.count = '0'
			state.amount = '0'
			state.volumeUnit = ''
			state.currentVolume = undefined
			state.itemDetail = undefined
			state.isItemChanged = []
		},
		initDeriveItems: state => {
			state.deriveItems = []
		},
		initEditItem: state => {
			state.editItem = undefined
		},
		setEditItemByIndex: (state, payload) => {
			state.editItem = Object.deepCopy(state.deriveItems[payload])
		},
		setEditItem: (state, payload) => {
			state.editItem = payload
		},
		saveAtDeriveItems: (state, payload) => {
			const { index, itemDetail } = payload
			state.deriveItems[index] = itemDetail
		},
		setItemDetail: (state, payload) => {
			state.itemDetail = payload
		},
		setOpenDatetime: (state, payload) => {
			state.editItem.openDatetime = payload
		},
		setDeriveItems: state => {
			state.deriveItems = []
			for (let i = 0; i < Number(state.count); i++) {
				state.deriveItems.push(Object.deepCopy(state.itemDetail))
				state.deriveItems[i].volume = state.capacity
			}
			state.isItemChanged = state.deriveItems.map(item => false)
		},
		setThreshold: (state, payload) => {
			state.editItem.threshold = payload
		},
		setThresholdUnit: (state, payload) => {
			state.editItem.thresholdUnit = payload
		},
		setExpireDatetime: (state, payload) => {
			state.editItem.expireDatetime = payload
		},
		setBuyDatetime: (state, payload) => {
			state.editItem.buyDatetime = payload
		},
		setCount: (state, payload) => {
			state.count = payload
		},
		setAmount: (state, payload) => {
			state.amount = payload
		},
		setCapacity: (state, payload) => {
			state.capacity = payload
		},
		setCurrentVolume: (state, payload) => {
			state.currentVolume = payload
		},
		setVolumeUnit: (state, payload) => {
			state.volumeUnit = payload
		},
		setItemIndex: (state, payload) => {
			state.itemIndex = payload
		},
		setPrice: (state, payload) => {
			state.editItem.price = payload
		},
		setPriceUnit: (state, payload) => {
			state.editItem.priceUnit = payload
		},
		setCheckTag: (state, payload) => {
			state.editItem.tagList = [...payload]
		},
		setLotNo: (state, payload) => {
			state.editItem.lotno = payload
		},
		setIncompanyMngcode: (state, payload) => {
			state.editItem.incompanyMngcode = payload
		},
		setMemo: (state, payload) => {
			state.editItem.memo = payload
		},
		setAssignee: (state, payload) => {
			state.editItem.assignee = { ...payload }
		},
		setBuyer: (state, payload) => {
			state.editItem.buyer = { ...payload }
		},
		setStorage: (state, payload) => {
			state.editItem.storage = { ...payload }
		},
		saveData: state => {
			state.deriveItems[state.itemIndex] = state.editItem
			state.isItemChanged[state.itemIndex] = true
		},
	},
	actions: {
		loadItemDetail: async ({ state, commit }, payload) => {
			const { instituteId, itemId } = payload
			const response = await inventoryAPI.lookupItemDetail(
				instituteId,
				itemId
			)
			commit('setItemDetail', response.data)
			commit('setCurrentVolume', response.data.currentVolume)
			commit('setVolumeUnit', response.data.volumeUnit)
		},
	},
}

export default index
